import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { DetailsSection, IagPortalRevisionNoticesPage } from 'src/app/model/page/group/iag-portal/iag-portal-revision-notices-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-revision-notices',
  templateUrl: './iag-portal-revision-notices.component.html',
  styleUrls: ['./iag-portal-revision-notices.component.scss']
})
export class IagPortalRevisionNoticesComponent {
  @Input() pageTitle = '';
  iagPortalRevisionNoticesPage: IagPortalRevisionNoticesPage = {} as IagPortalRevisionNoticesPage;
  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-product-update-notifications') {
        this.iagPortalRevisionNoticesPage.htmlTitle = title.htmlTitle;
      }
    });
  
    const query = { 'fields.pageTitle': this.pageTitle };
    this.iagPortalRevisionNoticesPage.detailsXMLSections = {} as DetailsSection;

    this.contentfulService.getIagRevisionNoticePageResponse(query).then((revisionNoticesPageEntries) => {
      this.mapBanners(revisionNoticesPageEntries);
      this.sharedDataService.addSharedData(this.iagPortalRevisionNoticesPage.banner);
      this.mapHtmlTitle(revisionNoticesPageEntries);
      this.mapRevisionNoticePageEntries(revisionNoticesPageEntries);
    });
  }
  private mapBanners(revisionNoticesPageEntries: Entry<any>[]) {
    revisionNoticesPageEntries.forEach((entry) => {
      this.mapEntryToBanner(entry);
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['bannerImage'];
    this.iagPortalRevisionNoticesPage.banner = {
      title: entry.fields['bannerTitle'] as string,
      subTitle: entry.fields['bannerSubtitle'] as string,
      image: image.fields.file.url,
      lastUpdated: entry.fields['lastUpdatedDate'] as string,
      url: entry.fields['url'] as string
    };
  }

  private mapHtmlTitle(entry: Entry<any>[]) {
    this.iagPortalRevisionNoticesPage.htmlTitle = entry[0].fields['htmlTitle'] as string;
  }

  private mapRevisionNoticePageEntries(revisionNoticesPageEntries: Entry<any>[]) {
    (revisionNoticesPageEntries || []).forEach((entry) => {
      this.mapDetailsXMLSection(entry);
    });
  }

  private mapDetailsXMLSection(entry: Entry<any>) {
    let detailsContent = entry.fields['detailsContent'] as string;
    if (typeof detailsContent !== 'undefined') {
      let constants: any = entry.fields['constants'];
      this.iagPortalRevisionNoticesPage.detailsXMLSections = {
        detailsTitle: constants?.Details,
        detailsBody: detailsContent
      };
    }
  }
}
